import { HHSLabel } from "config/appUrlConfig";
import { DimensionsById, IDimension, IDimFacility, IDimMDT, ISourceData, AddDataBaseFunc, DashboardBaseFilterFunc, IFilterKeys } from "../core";
import { AgeRange, Comorbidity, EcogGroup, IDashboardSharedViewModel, IndigenousGroup, Ses, Sex, TnmStage, Remoteness, HHSOfResidence } from "./plotdata";
import { DimensionsByKey } from "./plotdata/viewModel";

export { type IDashboardSharedViewModel, AgeRange, Comorbidity, EcogGroup, IndigenousGroup, Ses, Sex, TnmStage, Remoteness, HHSOfResidence } from "./plotdata";

/**
 * Shared dimensions / reference data
 */
export interface IDashboardSharedDimensionsViewModel {
    facilities?: { [facilityId: number]: IDimFacility };
    mdtNames?: { [mdtNameId: number]: IDimMDT };
    hhses?: DimensionsById;
    seses?: DimensionsById;
    ecogGroups?: DimensionsByKey;
    mdtsArray?: Array<IDimMDT>;
    facilitiesArray?: Array<IDimFacility>;
    hhsesArray?: Array<IDimension>;
    dataDate?: string;   
    monthsArray?: Array<IDimension>;
    yearsArray?: Array<IDimension>;
    months?: { [monthId: number]: string };
    years?: { [yearId: number]: string };
}

/**
 * Shared structure for all dashboard plotdata
 */
export interface IDashboardSharedChartData {
    comorbidities: Comorbidity.IPlotData;
    tnmStage: TnmStage.IPlotData;
    sex: Sex.IPlotData;
    ses: Ses.IPlotData;
    ageRange: AgeRange.IPlotData;
    indigenousGroup: IndigenousGroup.IPlotData;
    ecogGroup: EcogGroup.IPlotData;
    facilities: IDimFacility[];
    hhses: IDimension[];
    remoteness: Remoteness.IPlotData;
    hhsOfResidence: HHSOfResidence.IPlotData;
    //month: IDimension[];
    //year: IDimension[];
}

export type DashboardSharedFilterFunc<TViewModel extends IDashboardSharedViewModel> = DashboardBaseFilterFunc<TViewModel>;
export type AddDataSharedFunc<TViewModel extends IDashboardSharedViewModel, TSource extends ISourceData> = AddDataBaseFunc<TViewModel, TSource>;

export const DashboardSharedFilterKey: IFilterKeys = {
    Mdt: {key: "Mdt", label: "MDT"},
    Year: {key: "Year", label: "Period"},
    Sex: {key: "Sex", label: "Sex"},
    ComorbidityCount: {key: "ComorbidityCount", label: "Comorbidity count"},
    TnmStage: {key: "TnmStage", label: "Stage"},
    Facility: {key: "Facility", label: "Facility"},
    Ses: {key: "Ses", label: "Socio-economic status"},
    AgeRange: {key: "AgeRange", label: "Age at diagnosis"},
    IndigenousGroup: {key: "IndigenousGroup", label: "First Nations Group"},
    EcogGroup: {key: "EcogGroup", label: "ECOG"},
    HHS: {key: "HHS", label: HHSLabel},
}
